import React from 'react';
import TituloFollajeArtificial from '../components/sections/FollajeArtificial/TituloFollajeArtificial';
import IntroFollajeArtificial from '../components/sections/FollajeArtificial/IntroFollajeArtificial';
import FollajeTabs from '../components/sections/FollajeArtificial/FollajeTabs';
import EspecificacionesFollaje from '../components/sections/FollajeArtificial/EspecificacionesFollaje';
import AplicacionesFollaje from '../components/sections/FollajeArtificial/AplicacionesFollaje';
import CaracteristicasFollaje from '../components/sections/FollajeArtificial/CaracteristicasFollaje';
import BarraInfoNosotros from '../components/sections/BarraInfoNosotros';
import FormularioContactoFollaje from '../components/sections/FollajeArtificial/FormularioContactoFollaje';
import Header from '../components/layouts/Header';
import Footer from '../components/layouts/Footer';

const FollajeArtificialPage = () => {
    return (
        <div>
            <Header />
            <TituloFollajeArtificial />
            <IntroFollajeArtificial />
            <FollajeTabs />

            {/* Nuevas secciones: especificaciones, aplicaciones y ventajas del producto */}
            <EspecificacionesFollaje />
            {/*<AplicacionesFollaje />*/}
            <CaracteristicasFollaje />

            {/* Banda de marca (reutilizada de LVT), con fondo propio de Follaje */}
            <BarraInfoNosotros backgroundImage="/assets/img/productos/follaje-artificial/follaje-artificial-background.jpg" />

            <FormularioContactoFollaje />
            <Footer />
        </div>
    );
};

export default FollajeArtificialPage;